import React, { type MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';

import { getPlatformHref } from '@dashboard/hooks/navigate/usePlatformNavigator';
import { UnfoldMore } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';

type Props = {
  platforms: {
    id: string;
    name: string;
    environment: string;
  }[];
};
export default function PlatformsDropdownMenu({ platforms }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box flexShrink={0}>
      <IconButton
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          color: 'inherit',
        }}
      >
        <UnfoldMore fontSize="small" />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {platforms.map((p) => (
          <MenuItem
            key={p.id}
            component={Link}
            to={getPlatformHref(p.id)}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Box mr={2}>{p.name}</Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
